import React, {useState} from 'react';
import {Button, Row, Col} from 'antd';
import {FacebookOutlined, XOutlined, InstagramOutlined} from '@ant-design/icons';
import {openSignup} from '../../../utils/helpers';
import FeedbackPage from '../../../pages/Feedback/page';
import {trackEvent} from '../../../analytics/posthog';

const Footer: React.FC = () => {
    const [feedbackOpen, setFeedbackOpen] = useState(false);

    return (
        <footer className="bg-[#f2f2f2]">
            <div className="py-6">
                <div className="container">
                    <Row justify="space-between" align="middle">
                        <Col xs={24} lg={16} className="text-center lg:text-left">
                            <div className="font-sans">
                                <h2 className="text-2xl font-medium mt-3 mb-2">Ready to get started?</h2>
                                <p className="text-slate-400">Create your free account now</p>
                            </div>
                        </Col>

                        <Col xs={24} lg={8}>
                            <div className="flex items-center justify-center lg:justify-end gap-4 mt-4 lg:mt-0">
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        trackEvent('footer_signup_clicked', {
                                            signup_source: 'footer_signup'
                                        });
                                        openSignup(undefined, 'footer_signup');
                                    }}
                                    className="inline-flex items-center gap-2"
                                >
                                    <span>Sign up</span>
                                    <img src="/assets/images/plans-section/logo-white.svg" alt="" aria-hidden="true"
                                         className="w-4 h-4"/>
                                </Button>

                                <Button type="default" onClick={(e) => {
                                    e.preventDefault();
                                    trackEvent('footer_feedback_clicked');
                                    setFeedbackOpen(true);
                                }}>
                                    Send feedback
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <div className="border"/>

            <div className="container">
                <Row gutter={14} className="py-6 items-start">
                    <Col xs={24} md={10} className="text-center md:text-left">
                        <div>
                            <a href="/" aria-label="Promotify home">
                                <img src="assets/images/promotify-transparent.png" alt="Promotify logo"
                                     className="h-8 mx-auto md:mx-0"/>
                            </a>
                            <p className="text-gray-500/80 mt-5 font-sans max-w-[320px] mx-auto md:mx-0">
                                Organic marketing done right
                            </p>
                        </div>
                    </Col>

                    <Col xs={24} md={14} className="mt-8 md:mt-0">
                        <div className="flex justify-center md:justify-end">
                            <div className="flex gap-12 text-center md:text-left font-sans">

                                <div className="md:text-left">
                                    <h5 className="mb-3 uppercase">Company</h5>
                                    <div className="text-gray-500/80 mb-2"><a href="/about" onClick={() => trackEvent('footer_about_clicked', {destination: '/about'})}>About</a></div>
                                    <div className="text-gray-500/80 mb-2"><a href="/pricing" onClick={() => trackEvent('footer_pricing_clicked', {destination: '/pricing'})}>Pricing</a></div>
                                    <div className="text-gray-500/80 mb-2"><a href="/careers" onClick={() => trackEvent('footer_careers_clicked', {destination: '/careers'})}>Careers</a></div>
                                    <div className="text-gray-500/80 mb-2"><a href="/contact" onClick={() => trackEvent('footer_contact_clicked', {destination: '/contact'})}>Contact</a></div>
                                </div>

                                <div className="md:text-left">
                                    <h5 className="mb-3 uppercase">Legal</h5>
                                    <div className="text-gray-500/80 mb-2"><a href="/terms-and-conditions" onClick={() => trackEvent('footer_terms_clicked', {destination: '/terms-and-conditions'})}>Terms</a>
                                    </div>
                                    <div className="text-gray-500/80 mb-2"><a href="/privacy-policy" onClick={() => trackEvent('footer_privacy_clicked', {destination: '/privacy-policy'})}>Privacy</a></div>
                                    <div className="text-gray-500/80 mb-2"><a href="/refunds" onClick={() => trackEvent('footer_refunds_clicked', {destination: '/refunds'})}>Refunds</a></div>
                                    <div className="text-gray-500/80 mb-2"><a href="/cancellations" onClick={() => trackEvent('footer_cancellations_clicked', {destination: '/cancellations'})}>Cancellations</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            <div className="border-b"/>

            <div className="container">
                <Row className="py-5 text-center md:text-left">
                    <Col xs={24} md="auto">
                        <p className="text-sm text-slate-500 font-sans">
                            {new Date().getFullYear()} © Promotify. All rights reserved.
                        </p>
                    </Col>

                    <Col xs={24} md="auto" className="mt-4 md:mt-0">
                        <div className="flex justify-center md:justify-end gap-7 font-sans">
                            <div>
                                <a href="https://www.facebook.com/people/Promotify/61585635847291/" onClick={() => trackEvent('footer_facebook_clicked', {destination: 'facebook'})}>
                                    <FacebookOutlined
                                        className="w-5 h-5 text-slate-500/90 hover:text-[#1677ff] transition-all"/>
                                </a>
                            </div>
                            <div>
                                <a href="https://x.com/promotifyai" onClick={() => trackEvent('footer_x_clicked', {destination: 'x'})}>
                                    <XOutlined
                                        className="w-5 h-5 text-slate-500/90 hover:text-[#1677ff] transition-all"/>
                                </a>
                            </div>
                            <div>
                                <a href="https://www.instagram.com/promotifyai/" onClick={() => trackEvent('footer_instagram_clicked', {destination: 'instagram'})}>
                                    <InstagramOutlined
                                        className="w-5 h-5 text-slate-500/90 hover:text-[#1677ff] transition-all"/>
                                </a>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <FeedbackPage open={feedbackOpen} onClose={() => setFeedbackOpen(false)}/>
        </footer>
    );
};

export default Footer;
